import { render } from "./BuyListedNft.vue?vue&type=template&id=81d9c34e"
import script from "./BuyListedNft.vue?vue&type=script&lang=js"
export * from "./BuyListedNft.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__